import { Icon } from "%helpers";

export default {
  components: {
    Icon
  },

  props: {
    with: {
      type: [String, Array],
      required: true
    },
    defaultMessage: Boolean
  },

  computed: {
    permissions() {
      return typeof this.with === "string" ? [this.with] : this.with;
    },

    allowed() {
      return (
        this.$store.getters.permissions.filter(p =>
          this.permissions.includes(p)
        ).length === this.permissions.length
      );
    }
  },

  render(h) {
    if (this.allowed) {
      return this.$slots.default;
    } else if (this.defaultMessage) {
      return h("div", { class: ["grey-message"] }, [
        h("icon", { props: { name: "fa-minus-circle" } }),
        h("p", "Brak uprawnień do żądanego zasobu.")
      ]);
    }
  }
};
